<template>
  <a class="btn btn-default vue-skip-to" href="#" @click.prevent="onClick">
    <slot>{{ text }}</slot>
  </a>
</template>

<script>
/**
 * Inspired by https://github.com/vue-a11y/vue-skip-to
 */

export default {
  name: 'UiSkipTo',

  props: {
    text: {
      type: String,
      required: true,
    },
  },

  methods: {
    onClick() {
      document.getElementById('main').focus();
    },
  },
};
</script>

<style scoped lang="scss">
.vue-skip-to {
  position: absolute;
  top: 20px;
  left: -10000px;
  z-index: 6000;
  min-width: 1px;
  min-height: 1px;
  overflow: hidden;
}

.vue-skip-to:focus {
  left: 12px;
}
</style>
